import React from 'react';

export function CameraOn() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 7.5C3.89543 7.5 3 8.39543 3 9.5V14.5C3 15.6046 3.89543 16.5 5 16.5H13C14.1046 16.5 15 15.6046 15 14.5V9.5C15 8.39543 14.1046 7.5 13 7.5H5ZM16.5 10.9491C16.5 10.6634 16.6221 10.3914 16.8356 10.2017L19.3356 7.97943C19.9805 7.40618 21 7.86399 21 8.72684V15.2732C21 16.136 19.9805 16.5938 19.3356 16.0206L16.8356 13.7983C16.6221 13.6086 16.5 13.3366 16.5 13.0509V10.9491Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CameraOff() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.5303 4.53033C20.8232 4.23744 20.8232 3.76256 20.5303 3.46967C20.2374 3.17678 19.7626 3.17678 19.4697 3.46967L14.6168 8.32252L14.6162 8.32164L6.43781 16.5H6.43934L3.46967 19.4697C3.17678 19.7626 3.17678 20.2374 3.46967 20.5303C3.76256 20.8232 4.23744 20.8232 4.53033 20.5303L8.56066 16.5H13C14.1046 16.5 15 15.6046 15 14.5V10.0607L20.5303 4.53033Z"
        fill="#f63135"
      />
      <path
        d="M13.2949 7.52159C13.1987 7.50737 13.1002 7.5 13 7.5H5C3.89543 7.5 3 8.39543 3 9.5V14.5C3 15.3978 3.59155 16.1574 4.40614 16.4104L13.2949 7.52159Z"
        fill="#f63135"
      />
      <path
        d="M16.5 10.9491C16.5 10.6634 16.6221 10.3914 16.8356 10.2017L19.3356 7.97943C19.9805 7.40618 21 7.86399 21 8.72684V15.2732C21 16.136 19.9805 16.5938 19.3356 16.0206L16.8356 13.7983C16.6221 13.6086 16.5 13.3366 16.5 13.0509V10.9491Z"
        fill="#f63135"
      />
    </svg>
  );
}

export function MicrophoneOn() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C10.3431 3 9 4.34315 9 6V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12V6C15 4.34315 13.6569 3 12 3ZM7.5 12C7.5 11.5858 7.16421 11.25 6.75 11.25C6.33579 11.25 6 11.5858 6 12C6 13.9175 6.62158 15.4436 7.73826 16.4858C8.67527 17.3603 9.90114 17.8386 11.25 17.9654V20.25C11.25 20.6642 11.5858 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V17.9654C14.0989 17.8386 15.3247 17.3603 16.2617 16.4858C17.3784 15.4436 18 13.9175 18 12C18 11.5858 17.6642 11.25 17.25 11.25C16.8358 11.25 16.5 11.5858 16.5 12C16.5 13.5825 15.9966 14.6814 15.2383 15.3892C14.4713 16.105 13.3583 16.5 12 16.5C10.6417 16.5 9.52867 16.105 8.76174 15.3892C8.00342 14.6814 7.5 13.5825 7.5 12Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MicrophoneOff() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 3C13.5979 3 14.904 4.24928 14.9949 5.8244L9 11.8193V6C9 4.34315 10.3431 3 12 3Z"
        fill="#f63135"
      />
      <path
        d="M15 10.0607L20.5303 4.53033C20.8232 4.23744 20.8232 3.76256 20.5303 3.46967C20.2374 3.17678 19.7626 3.17678 19.4697 3.46967L3.46967 19.4697C3.17678 19.7626 3.17678 20.2374 3.46967 20.5303C3.76256 20.8232 4.23744 20.8232 4.53033 20.5303L8.19557 16.8651C9.05938 17.5005 10.1108 17.8583 11.25 17.9654V20.25C11.25 20.6642 11.5858 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V17.9654C14.0989 17.8386 15.3247 17.3603 16.2617 16.4858C17.3784 15.4436 18 13.9175 18 12C18 11.5858 17.6642 11.25 17.25 11.25C16.8358 11.25 16.5 11.5858 16.5 12C16.5 13.5825 15.9966 14.6814 15.2383 15.3892C14.4713 16.105 13.3583 16.5 12 16.5C10.919 16.5 9.9933 16.2498 9.27382 15.7868L10.476 14.5846C10.9227 14.8486 11.4436 15 12 15C13.6569 15 15 13.6569 15 12V10.0607Z"
        fill="#f63135"
      />
      <path
        d="M7.6111 13.2082C7.53881 12.8415 7.5 12.4394 7.5 12C7.5 11.5858 7.16421 11.25 6.75 11.25C6.33579 11.25 6 11.5858 6 12C6 12.8969 6.13599 13.7082 6.39503 14.4243L7.6111 13.2082Z"
        fill="#f63135"
      />
    </svg>
  );
}

export function Screenshare() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 4.5H7C5.61929 4.5 4.5 5.61929 4.5 7V14C4.5 15.3807 5.61929 16.5 7 16.5H17C18.3807 16.5 19.5 15.3807 19.5 14V7C19.5 5.61929 18.3807 4.5 17 4.5ZM6 7C6 6.44772 6.44772 6 7 6H17C17.5523 6 18 6.44772 18 7V14C18 14.5523 17.5523 15 17 15H7C6.44772 15 6 14.5523 6 14V7ZM8 18C7.58579 18 7.25 18.3358 7.25 18.75C7.25 19.1642 7.58579 19.5 8 19.5H16C16.4142 19.5 16.75 19.1642 16.75 18.75C16.75 18.3358 16.4142 18 16 18H8Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Leave() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 4.5H14C15.3807 4.5 16.5 5.61929 16.5 7V10H15V7C15 6.44772 14.5523 6 14 6H7C6.44772 6 6 6.44772 6 7V17C6 17.5523 6.44772 18 7 18H14C14.5523 18 15 17.5523 15 17V14H16.5V17C16.5 18.3807 15.3807 19.5 14 19.5H7C5.61929 19.5 4.5 18.3807 4.5 17V7C4.5 5.61929 5.61929 4.5 7 4.5Z"
        fill="#f63135"
      />
      <path
        d="M19.0303 8.46967C18.7374 8.17678 18.2626 8.17678 17.9697 8.46967C17.6768 8.76256 17.6768 9.23744 17.9697 9.53033L19.6893 11.25H12.75C12.3358 11.25 12 11.5858 12 12C12 12.4142 12.3358 12.75 12.75 12.75H19.6893L17.9697 14.4697C17.6768 14.7626 17.6768 15.2374 17.9697 15.5303C18.2626 15.8232 18.7374 15.8232 19.0303 15.5303L22.0303 12.5303C22.3232 12.2374 22.3232 11.7626 22.0303 11.4697L19.0303 8.46967Z"
        fill="#f63135"
      />
    </svg>
  );
}

export function Info() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25Z"
        stroke="#121A24"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0055 9C12.5519 9 13 8.56069 13 8.00578C13 7.43931 12.5519 7 12.0055 7C11.4481 7 11 7.43931 11 8.00578C11 8.56069 11.4481 9 12.0055 9Z"
        fill="#121A24"
      />
      <path
        d="M12 11V16"
        stroke="#121A24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChatIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18C16.4183 18 20 14.866 20 11C20 7.13401 16.4183 4 12 4C7.58172 4 4 7.13401 4 11C4 12.4358 4.49404 13.7707 5.3415 14.8815C5.47613 15.1546 5.75357 16.0287 5 17.7364C4.63024 18.4941 4.46711 19 5 19C6.12068 19 6.64893 18.6353 7.19788 18.2563C7.65602 17.9399 8.12858 17.6137 8.97197 17.4812C9.90599 17.8156 10.9284 18 12 18Z"
        fill="#121A24"
      />
    </svg>
  );
}

export function ChatHighlighted() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18C16.4183 18 20 14.866 20 11C20 7.13401 16.4183 4 12 4C7.58172 4 4 7.13401 4 11C4 12.4358 4.49404 13.7707 5.3415 14.8815C5.47613 15.1546 5.75357 16.0287 5 17.7364C4.63024 18.4941 4.46711 19 5 19C6.12068 19 6.64893 18.6353 7.19788 18.2563C7.65602 17.9399 8.12858 17.6137 8.97197 17.4812C9.90599 17.8156 10.9284 18 12 18Z"
        fill="#f63135"
      />
    </svg>
  );
}

export function Arrow() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 11.25C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75V11.25ZM19 12L19.5303 12.5303C19.8232 12.2374 19.8232 11.7626 19.5303 11.4697L19 12ZM14.5303 6.46967C14.2374 6.17678 13.7626 6.17678 13.4697 6.46967C13.1768 6.76256 13.1768 7.23744 13.4697 7.53033L14.5303 6.46967ZM13.4697 16.4697C13.1768 16.7626 13.1768 17.2374 13.4697 17.5303C13.7626 17.8232 14.2374 17.8232 14.5303 17.5303L13.4697 16.4697ZM5 12.75H19V11.25H5V12.75ZM19.5303 11.4697L14.5303 6.46967L13.4697 7.53033L18.4697 12.5303L19.5303 11.4697ZM18.4697 11.4697L13.4697 16.4697L14.5303 17.5303L19.5303 12.5303L18.4697 11.4697Z"
        fill="#121A24"
      />
    </svg>
  );
}
